/**
 * Progress Blocks – Scroll-based progress fill.
 * Desktop (≥981px): instant fill when section enters viewport.
 * Tablet & mobile (<981px): squares and vertical lines fill step-by-step on scroll.
 */
(function() {
  const DESKTOP_MIN = 981;

  function isDesktop() {
    return window.innerWidth >= DESKTOP_MIN;
  }

  function setDesktopInView(section, inView) {
    section.classList.toggle('el-progress-blocks-section--in-view', !!inView);
  }

  function updateDesktopProgress(section) {
    const rect = section.getBoundingClientRect();
    const inView = rect.top < window.innerHeight && rect.bottom > 0;
    setDesktopInView(section, inView);
  }

  function updateMobileProgress(section) {
    const blocks = section.querySelectorAll('[data-progress-block]');
    if (blocks.length === 0) return;

    const sectionRect = section.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const sectionHeight = section.offsetHeight;

    /* Section progress 0→1 as user scrolls through the section (first block to last) */
    let sectionProgress = (viewportHeight - sectionRect.top) / (viewportHeight + sectionHeight);
    sectionProgress = Math.max(0, Math.min(1, sectionProgress));

    const n = blocks.length;
    blocks.forEach(function(block, index) {
      const segmentStart = index / n;
      const segmentSize = 1 / n;
      /* Block fill: 0 until section progress enters its segment, then 0→1 within segment */
      let blockFill = (sectionProgress - segmentStart) / segmentSize;
      blockFill = Math.max(0, Math.min(1, blockFill));

      block.style.setProperty('--block-fill', String(blockFill));

      const square = block.querySelector('.el-progress-blocks__square--mobile');
      if (square) {
        square.classList.toggle('el-progress-blocks__square--filled', blockFill >= 0.15);
      }
    });
  }

  function updateProgress(section) {
    if (isDesktop()) {
      updateDesktopProgress(section);
    } else {
      updateMobileProgress(section);
    }
  }

  function initSection(section) {
    if (typeof IntersectionObserver !== 'undefined' && isDesktop()) {
      const io = new IntersectionObserver(
        function(entries) {
          entries.forEach(function(entry) {
            setDesktopInView(entry.target, entry.isIntersecting);
          });
        },
        { rootMargin: '50px 0px', threshold: 0 }
      );
      io.observe(section);
    }

    const handleScroll = function() {
      updateProgress(section);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', function() {
      updateProgress(section);
    });

    updateProgress(section);
  }

  function run() {
    document.querySelectorAll('.el-progress-blocks-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      const section = e.target.querySelector('.el-progress-blocks-section');
      if (section) initSection(section);
    });
  }
})();
